import React, {useEffect, useState} from 'react';
import {useParams, useNavigate} from "react-router-dom";
import Hashids from 'hashids'
import {apiPath, serverToken, mapBoxApiKey} from "../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";
import TripItem from "../components/TripItem";
import moment from 'moment';

function TripDetails() {

    const navigate = useNavigate();
    const hashids = new Hashids('', 10)

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);

    let {id} = useParams();


    useEffect(() => {

        let decodedID = hashids.decode(id)

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/get-request-details/' + decodedID[0], {headers})
            .then(data => {
                setData(data.data);
                setIsLoading(false);
            })

            .catch(error => {
                setIsLoading(false);
            });

    }, []);

    if (!data) {
        return (
            <div className="container mx-auto h-screen flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    const handelUserPhone = (phone) => {

        if (phone === 'empty') {
            return "No disponible"
        } else {
            return phone;
        }


    }

    const handleBaggage = (baggage) => {

        switch (baggage) {

            case "N":
                return "Ninguno"

            case "P":
                return "Poco"

            case "M":
                return "Mucho"

            default:
                return "No definido"
        }
    }

    const handlePets = (pets) => {

        if (pets === "N") {
            return "No"
        } else {
            return "Si"
        }
    }

    const handleCarCategory = (category) => {

        if (category === "S") {
            return "Estandar"
        } else {
            return "Confort"
        }

    }

    const handleFormatDate = (date) => {
        return moment(date).format('DD - MM - YYYY ( hh:mm:ss )')
    }

    const handleTripStatus = (status) => {

        switch (status) {
            case "P":
                return "Pendiente"

            case "C":
                return "Cancelado"

            case "A":
                return "Aprobado"
        }
    }

    //----------------------------------------------------------------//
    const handleTripApprove = (tripID) => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/approve-trip/' + tripID, {headers})
            .then(data => {
                setIsLoading(false);
                navigate('/admin/solicitudes');
            })

            .catch(error => {
                setIsLoading(false);
                navigate('/admin/solicitudes');
            });
    }

    const handleTripCancel = (tripID) => {

        let userID = JSON.parse(localStorage.getItem('user'))

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/cancel-trip?id='+ tripID +'&user=' + userID.id, {headers})
            .then(data => {
                setIsLoading(false);
                navigate('/admin/solicitudes');
            })

            .catch(error => {
                setIsLoading(false);
                navigate('/admin/solicitudes');
            });
    }

    const handleTripRefundCredit = (tripID) => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/refund-trip-credit/' + tripID, {headers})
            .then(data => {
                setIsLoading(false);
                navigate('/admin/solicitudes');
            })

            .catch(error => {
                setIsLoading(false);
                navigate('/admin/solicitudes');
            });

    }


    if (isLoading) {
        return (
            <div className="container mx-auto h-screen flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    return (
        <>
            <div className="flex items-center justify-center py-8 px-4">
                <div className="w-full md:w-1/2 rounded-md shadow-sm py-8 px-5 dark:bg-gray-600 bg-white">

                    <div className="relative flex pb-5 items-center">
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                        <p className="flex-shrink mx-4 text-gray-600 dark:text-gray-100">Detalles de la solicitud</p>
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                    </div>

                    <img className="w-full rounded-[10px] shadow mb-5"
                         src={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-s-a+9ed4bd(${data.trip.client_lon},${data.trip.client_lat}),pin-s-b+000(${data.trip.destination_lon},${data.trip.destination_lat})/auto/1024x500?access_token=${mapBoxApiKey}`}/>

                    <p className="text-gray-600 dark:text-gray-100">Información del cliente</p>

                    <div className="grid grid-cols-1">

                        <TripItem
                            icon={
                                <img
                                    src={data.trip.user.avatar !== "null" ? data.trip.user.avatar : "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909__340.png"}
                                    className="w-full h-full rounded" alt=""/>
                            }
                            title={"Nombre del cliente"}
                            description={data.trip.user.name}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/>
                                </svg>

                            }
                            title={"Teléfono"}
                            description={handelUserPhone(data.trip.client_phone)}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/>
                                </svg>

                            }
                            title={"Contacto WhatsApp"}
                            description={handelUserPhone(data.trip.client_whatsapp_contact)}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round"
                                          d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"/>
                                </svg>

                            }
                            title={"Correo"}
                            description={data.trip.user.email}
                        />
                    </div>

                    <p className="text-gray-600 dark:text-gray-100">Información del viaje</p>

                    <div className="grid grid-cols-1">
                        <TripItem
                            icon={

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/>
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/>
                                </svg>

                            }
                            title={"Dirección de salida"}
                            description={data.trip.client_address}
                        />

                        <TripItem

                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="h-6 w-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/>
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/>
                                </svg>

                            }
                            title={"Dirección de llegada"}
                            description={data.trip.destination_address}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"/>
                                </svg>

                            }
                            title={"Cantidad de pasajeros"}
                            description={data.trip.passengers + " personas"}
                        />


                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
                                </svg>


                            }
                            title={"Cantidad de equipaje"}
                            description={handleBaggage(data.trip.baggage)}
                        />

                        {data.trip.baggage !== "N" ?

                            <TripItem
                                icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5} stroke="currentColor"
                                         className="w-6 h-6  text-sky-400 dark:text-gray-100">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"/>
                                    </svg>

                                }
                                title={"Nota de equipaje"}
                                description={data.trip.baggage_note}
                            />
                            :
                            ""}

                        <TripItem
                            icon={

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6  text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/>
                                </svg>

                            }
                            title={"Mascotas"}
                            description={handlePets(data.trip.pets)}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"/>
                                </svg>

                            }
                            title={"Categoría de auto"}
                            description={handleCarCategory(data.trip.car_type)}
                        />

                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/>
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/>
                                </svg>
                            }
                            title={"Distancia"}
                            description={data.trip.trip_distance + " KM"}
                        />


                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"/>
                                </svg>
                            }
                            title={"Método de pago"}
                            description={data.trip.payment_method}
                        />


                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"/>
                                </svg>

                            }
                            title={"Fecha de solicitud"}
                            description={handleFormatDate(data.trip.created_at)}
                        />

                        {data.trip.trip_schedule_date !== "empty" && data.trip.trip_schedule_time !== "empty" ?

                            <TripItem
                                icon={

                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         strokeWidth={1.5} stroke="currentColor"
                                         className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                    </svg>

                                }
                                title={"Viaje programado"}
                                description={data.trip.trip_schedule_date + " | " + data.trip.trip_schedule_time}
                            />
                            :
                            ""
                        }


                        <TripItem
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     strokeWidth={1.5} stroke="currentColor"
                                     className="w-6 h-6 text-sky-400 dark:text-gray-100">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"/>
                                </svg>
                            }
                            title={"Estado de solicitud"}
                            description={handleTripStatus(data.trip.status)}
                        />


                    </div>
                    <div className="relative flex pb-5 items-center">
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                    </div>

                    <div className="flex justify-between">
                        <p className="flex-shrink mx-4 text-gray-600 dark:text-gray-100">Costo del viaje:</p>
                        <p className="flex-shrink mx-4 text-gray-600 dark:text-gray-100">{data.trip.price} CUP</p>
                    </div>

                    <div className="relative flex pt-5 items-center">
                        <div className="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
                    </div>

                    {data.trip.status === 'P' ?
                        <div className="flex justify-end my-5 gap-x-4">
                            <button
                                onClick={() => handleTripCancel(data.trip.id)}
                                className="px-10 py-2 bg-white border hover:bg-gray-100 text-gray-800 rounded-full">Cancelar
                            </button>
                            <button
                                onClick={() => handleTripApprove(data.trip.id)}
                                className="px-10 py-2 bg-sky-500 hover:bg-sky-400 text-white rounded-full">Aprobar
                            </button>
                        </div>
                        :
                        <div>
                        </div>
                    }

                    { data.trip.status === 'A' && data.trip.payment_method === 'Billetera' && data.trip.refunded_money === 0 ?

                        <div className="flex justify-end my-5 gap-x-4">
                            <button
                                onClick={() => handleTripRefundCredit(data.trip.id)}
                                className="px-10 py-2 bg-white border hover:bg-gray-100 text-gray-800 rounded-full">Reembolsar credito
                            </button>
                        </div>
                        :
                        ""
                    }

                </div>
            </div>
        </>
    );
}

export default TripDetails;